// LiveStreamBadge.js
import { connect } from 'react-redux';

import { FEATURE_LIVESTREAM_CARD_FUNDING_PROGRESS_RATIO } from '../RemoteConfigKeys.js';

import LiveStreamBadge from '../component/LiveStreamBadge.jsx';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const mapStateToProps = (state, { streamId }) => {
  const timestampOffsetSeconds = getTimestampOffset(state, Accuracy.SECOND);
  const runningShowId = getLiveStreamData(state, [streamId], 'runningShowId');
  const fundingExp = getLiveStreamData(
    state,
    [streamId, 'show', runningShowId, 'metadata'],
    'fundingExp'
  );
  const modeName = getLiveStreamData(state, [streamId, 'mode'], 'name');
  const nextModeName = getLiveStreamData(state, [streamId, 'nextMode'], 'name');
  const fundingTarget = getLiveStreamData(
    state,
    [streamId, 'show', runningShowId, 'metadata'],
    'fundingTarget'
  );
  const fundingProgress = getLiveStreamData(
    state,
    [streamId, 'show', runningShowId, 'metadata'],
    'fundingProgress'
  );
  const isFundingProgressRatioEnabled =
    getRemoteConfigData(
      state,
      FEATURE_LIVESTREAM_CARD_FUNDING_PROGRESS_RATIO
    ) === 1;
  return {
    modeName,
    nextModeName,
    runningShowId,
    timestampOffsetSeconds,
    fundingExp,
    fundingTarget,
    fundingProgress,
    isFundingProgressRatioEnabled,
  };
};

export default connect(
  mapStateToProps,
  null,
  // equals to `{ ...ownProps, ...stateProps, ...dispatchProps }`
  // ref: https://github.com/reduxjs/react-redux/blob/v7.1.0/src/connect/mergeProps.js
  null,
  { forwardRef: true } // Required by WithIntersectionObserver
)(LiveStreamBadge);
